export const WEEKDAY_OPTIONS = [
  { value: 0, label: "月" },
  { value: 1, label: "火" },
  { value: 2, label: "水" },
  { value: 3, label: "木" },
  { value: 4, label: "金" },
  { value: 5, label: "土" },
  { value: 6, label: "日" },
];

export const MONTHDAY_OPTIONS = Array.from({ length: 31 }, (_, index) => ({
  value: index + 1,
  label: `${index + 1}日`,
}));

function normalizeNumberList(values, min, max) {
  return [...new Set((values || []).map(Number))]
    .filter((value) => Number.isInteger(value) && value >= min && value <= max)
    .sort((a, b) => a - b);
}

export function normalizeScheduleSetting(setting = {}) {
  const recurrenceType = ["daily", "weekly", "monthly"].includes(setting.recurrence_type)
    ? setting.recurrence_type
    : "daily";
  const weeklyDays = normalizeNumberList(setting.weekly_days, 0, 6);
  const monthlyDays = normalizeNumberList(setting.monthly_days, 1, 31);

  return {
    ...setting,
    recurrence_type: recurrenceType,
    weekly_days: recurrenceType === "weekly" ? weeklyDays : [],
    monthly_days: recurrenceType === "monthly" ? monthlyDays : [],
  };
}

export function validateScheduleSetting(setting = {}) {
  const normalized = normalizeScheduleSetting(setting);
  if (normalized.recurrence_type === "weekly" && normalized.weekly_days.length === 0) {
    return "毎週を選ぶ場合は曜日を1つ以上選択してください。";
  }
  if (normalized.recurrence_type === "monthly" && normalized.monthly_days.length === 0) {
    return "毎月を選ぶ場合は日付を1つ以上選択してください。";
  }
  return "";
}

export function formatTaskSchedule(recurrenceType, weeklyDays, monthlyDays) {
  if (!recurrenceType) {
    return null;
  }
  if (recurrenceType === "daily") {
    return "毎日";
  }
  if (recurrenceType === "weekly") {
    const labels = normalizeNumberList(weeklyDays, 0, 6)
      .map((day) => WEEKDAY_OPTIONS.find((option) => option.value === day)?.label)
      .filter(Boolean);
    return labels.length ? `毎週 ${labels.join("・")}曜` : "毎週";
  }
  if (recurrenceType === "monthly") {
    const labels = normalizeNumberList(monthlyDays, 1, 31)
      .map((day) => `${day}日`);
    return labels.length ? `毎月 ${labels.join("・")}` : "毎月";
  }
  return null;
}
